import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);
const router =  new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths,
  mode: 'history'
});
const DEFAULT_TITLE = 'ordervanthuan.com';
// router gards
router.beforeEach((to, from, next) => {
  NProgress.start();
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
        next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        })
    } else {
        let user = JSON.parse(localStorage.getItem('user'))
        let isSaleOnly = user && (user.roletype & 1024) === 1024 && (user.roletype & 1) !== 1;
        if (isSaleOnly) {
            const saleAllowedRoutes = [
                'OrderList', 'OrderDetail',
                'Deposit', 'DepositDetail',
                'PayServiceList', 'PayServiceDetail',
                'CustomerList', 'CustomerDetail'
            ];
            if (to.name === 'Dashboard' || to.name === 'Root' || to.path === '/' || to.path === '/dashboard') {
                next({ name: 'OrderList' });
                return;
            }
            if (saleAllowedRoutes.includes(to.name)) {
                next();
                return;
            } else {
                next({ name: 'NotFound' });
                return;
            }
        }
        if(to.matched.some(record => record.meta.is_admin)) {
            next({ name: 'dashboard'})
        }else {
            try {
                let vuex = localStorage.getItem('vuex');
                vuex = JSON.parse(vuex);
                let role = _.reduce(_.filter(vuex.roles.all.data, function(obj) {
                    return (obj.RoleType & user.roletype) == obj.RoleType;  
                }), function(result, obj) {
                    result.Module = result.Module | obj.Module;
                    result.Report = result.Report | obj.Report;
                    return result;
                }, {Module: 0, Report: 0})
                if ((user.roletype & 1024) === 1024) {
                    role.Module = role.Module | 104;
                    role.Report = role.Report | 0;
                }

                if(to.meta.roleId & role.Module && (!to.meta.reportRoleId || (to.meta.reportRoleId & role.Report))) {
                    next()
                }
                else {
                    next({name: 'NotFound'})
                }
            } catch (error) {
                next({
                    path: '/login',
                    params: { nextUrl: to.fullPath }
                })
            }
        }
    }
    } else if(to.matched.some(record => record.meta.public)) {
        if(localStorage.getItem('jwt') == null){
            next()
        }
        else{
            let user = JSON.parse(localStorage.getItem('user'));
            let isSaleOnly = user && (user.roletype & 1024) === 1024 && (user.roletype & 1) !== 1;
            if (isSaleOnly) {
                next({ name: 'OrderList'});
            } else {
                next({ name: 'dashboard'});
            }
        }
    }else {
        if (localStorage.getItem('jwt') != null) {
            let user = JSON.parse(localStorage.getItem('user'));
            let isSaleOnly = user && (user.roletype & 1024) === 1024 && (user.roletype & 1) !== 1;
            if (isSaleOnly && (to.name === 'Root' || to.path === '/')) {
                next({ name: 'OrderList' });
                return;
            }
        }
        next() 
    }
    Vue.nextTick(() => {
        document.title = to.meta.title ? to.meta.title + (to.params.Pid ? ' #' + to.params.Pid : '') + ' | ' + DEFAULT_TITLE : DEFAULT_TITLE;
    });
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
